// extracted by css-extract-rspack-plugin
export default {"analysisWrapper":"VMZxh"};